import React, { useState } from 'react';
import { TextInput } from 'carbon-components-react';

const TextFormControl = props => {
  const [value, setValue] = useState(props.formData);
  const onChange = event => {
    setValue(event.target.value);
    props.onChange(event.target.value);
  };

  return (
    <TextInput
      id={props.idSchema.$id}
      type={props.uiSchema['ui:options'] || 'text'}
      labelText={props.schema.title}
      placeholder={props.schema.placeholder}
      light
      invalid={false}
      invalidText='A valid value is required'
      onChange={onChange}
      value={value || ''}
      disabled={props.schema.readOnly}
      style={{ width: 200, minWidth: 250 }}
    />
  );
};

export default TextFormControl;
